module.exports = __webpack_public_path__ + "img/nema-logo.1ec1e979.png";